/** Tema escolhido pela pessoa. "sistema" segue o aparelho. Guardado só neste navegador (conforto, não dado). */
export type Tema = "sistema" | "claro" | "escuro";
const CHAVE = "fa-tema";

export function lerTema(): Tema {
  try {
    const v = localStorage.getItem(CHAVE);
    return v === "claro" || v === "escuro" ? v : "sistema";
  } catch {
    return "sistema";
  }
}

export function aplicarTema(t: Tema) {
  const raiz = document.documentElement;
  if (t === "sistema") delete raiz.dataset.theme;
  else raiz.dataset.theme = t === "claro" ? "light" : "dark";
  try {
    if (t === "sistema") localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, t);
  } catch {
    /* navegador sem armazenamento: vale só nesta aba */
  }
}
